import React from 'react';
import { View } from 'react-native';

import styles from './styles';

const sparklePositions = [
  { top: '8%', left: '25%' },
  { top: '22%', right: '25%' },
  { top: '45%', left: '15%' },
  { top: '68%', right: '20%' },
  { top: '85%', left: '30%' },
  { top: '15%', left: '80%' },
  { top: '55%', right: '10%' },
  { top: '75%', left: '65%' },
];

const Sparkles: React.FC = () => (
  <>
    {sparklePositions.map((sparkle, idx) => {
      const style: any = {
        position: 'absolute',
        opacity: 0.6,
      };
      if (sparkle.left) style.left = sparkle.left;
      if (sparkle.right) style.right = sparkle.right;
      if (sparkle.top) style.top = sparkle.top;
      return <View key={idx} style={[styles.sparkle, style]} />;
    })}
  </>
);

export default Sparkles;
